import React from 'react';

class RadioInput extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      selected: props.defaultValue || null,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange (value) {
    return () => {
      this.setState({
        selected: value,
      });

      if (this.props.onChange) {
        this.props.onChange({
          target: {
            value
          }
        });
      }
    };
  }

  sortOptions (Options) {
    let Data = [...Options];
    Data.sort(function (a, b) {
      if (a.sequence - b.sequence !== 0) {
        return a.sequence - b.sequence;
      }
      return a.id - b.id;
    });
    return Data;
  }

  render () {
    return (
      <div className='RadioInput__Wrapper'>
        {this.sortOptions(this.props.field.field_options).map(option => (
          <div className='clearfix RadioInput__Option' key={'RadioInput__' + option.id}>
            <input onChange={this.handleChange(option.option_value)}
              value={option.option_value} checked={this.state.selected === option.option_value}
              type='radio' id={'RadioInput__' + option.id} />
            <label className='RadioInput__Label' htmlFor={'RadioInput__' + option.id}>{option.option_value}</label>
          </div>
        ))}
      </div>
    );
  }
}

export default RadioInput;



// WEBPACK FOOTER //
// ./src/routes/modules/routes/ViewComponent/components/ComponentWrapper/inputs/radio.js